import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Helmet } from 'react-helmet-async';
import { PAGES } from '../../constants/pages';
import SelectList from '../../components/SelectList/SelectList';
import BaseLayout from '../../components/BaseLayout';
import { Heading } from '../../components/Heading';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const CreateApplicationRetirement = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { BrokerName } = useSelector(selectSettings);

  const options = [
    {
      title: t('selectPath.options.retirement.owner.me'),
      onClick: () => {
        history.push(PAGES.CREATE_APPLICATION.RETIREMENT.PERSONAL);
      },
      showDivider: true,
    },
    {
      title: t('selectPath.options.retirement.owner.business'),
      onClick: () => {
        history.push(PAGES.CREATE_APPLICATION.RETIREMENT.BUSINESS);
      },
      showDivider: false,
    },
  ];

  return (
    <BaseLayout
      canShowEmail={false}
      previousPath={PAGES.CREATE_APPLICATION.MAIN}
    >
      <Helmet>
        <title>
          {t('selectPath.options.retirement.titleTag', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={28}>
        {t('selectPath.options.retirement.owner.title')}
      </Heading>
      <SelectList options={options} />
    </BaseLayout>
  );
};

export default CreateApplicationRetirement;
